const configErrors = {
  'user.superAdminInCompany': {
    SAemail: 'errors.companySuperAdminExisting',
  },
  'user.emailAlreadyInUse': {
    SAemail: 'errors.companySuperAdminExisting',
  },
  'company.name': {
    name: 'errors.companyNameIsNotMatchPattern',
  },
  'company.alreadyExists': {
    name: 'errors.companyExisting',
  },
  'company.SAfirstName': {
    SAfirstName: 'errors.firstNameIsNotMatchPattern',
  },
  'company.SAlastName': {
    SAlastName: 'errors.lastNameIsNotMatchPattern',
  },
  'company.defaultJobRolesRequiredForTemplates': {
    defaultJobRoles: 'errors.jobTasksIsRequired',
  },
  'company.organizationalJobRolesRequiredForTemplates': {
    organizationalJobRoles: 'errors.jobTasksIsRequired',
  },
  'company.stations': {
    stationsCurrent: 'errors.companyStationsIsInvalid',
  },
  'companies.badStationsArray': {
    stationsCurrent: 'errors.companyStationsIsInvalid',
  },
  'company.mainColor': {
    mainColor: 'errors.colorIsInvalid',
  },
  'company.fontMainColor': {
    fontMainColor: 'errors.colorIsInvalid',
  },
  'company.jobRoleVersionsRequired': {
    jobRoles: 'company.jobRoleVersionsRequired',
  },
  'company.trainingPartVersionsRequired': {
    trainingModules: 'company.trainingPartVersionsRequired',
  },
};

export default configErrors;
